<template>
  <vue-scroll>
    <el-drawer
      :title="title"
      append-to-body
      :visible.sync="drawer"
      size="60%"
      v-bind="$attrs"
    >
      <el-container>
        <el-main>
          <el-row>
            <el-col>
              <span class="info-text mr-10">Filtrar por rango de fecha</span>
              <el-date-picker
                v-model="dateFilter"
                type="datetimerange"
                range-separator="To"
                start-placeholder="Start date"
                end-placeholder="End date"
                size="mini"
                format="yyyy-MM-dd HH:mm:ss"
                @blur="handleBlurDateFilter"
              ></el-date-picker>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <div class="card-base card-shadow--medium">
                <el-table
                  :data="items"
                  :max-height="420"
                  stripe
                  border
                  style="width: 100%"
                  v-loading="loading"
                >
                  <el-table-column
                    prop="tracker_id"
                    label="GPS ID #"
                    :min-width="80"
                    sortable
                    fixed
                  ></el-table-column>
                  <el-table-column
                    prop="id"
                    label="Evento ID #"
                    :min-width="80"
                    sortable
                    fixed
                  ></el-table-column>
                  <el-table-column
                    prop="event"
                    label="Event"
                    :min-width="100"
                    sortable
                  >
                    <template slot-scope="scope">
                      <span>{{ getTypeDescription(scope.row.event) }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="message"
                    label="Message"
                    :min-width="250"
                  ></el-table-column>
                  <el-table-column
                    prop="time"
                    label="Time"
                    sortable
                    :width="170"
                  ></el-table-column>
                  <el-table-column
                    v-if="false"
                    prop="location.address"
                    label="Ubicacion"
                    :min-width="170"
                  ></el-table-column>
                </el-table>
                <div style="margin: 10px">
                  <el-pagination
                    style="margin-top: 20px"
                    layout="total, sizes, prev, pager, next, jumper"
                    :current-page="pagination.currentPage"
                    :page-size="pagination.pageSize"
                    :total="pagination.total"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                  />
                </div>
              </div>
            </el-col>
          </el-row>
        </el-main>
      </el-container>
    </el-drawer>
  </vue-scroll>
</template>
<script>
import { mapActions, mapState } from "vuex";
import { getPaginatedItems, formatDate } from "@/utils";

export default {
  name: "ReportGpsDetailHistory",
  components: {},
  data() {
    return {
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      dateFilter: [new Date(2020, 8, 10, 10, 10), new Date(Date.now())],
      drawer: false,
      loading: false,
      title: "Historial de gps",
      columns: [
        {
          prop: "id",
          label: "#",
          sortable: true
        },
        {
          prop: "event",
          label: "Event"
        },
        {
          prop: "message",
          label: "Message"
        },
        {
          prop: "time",
          label: "Time"
        }
      ],
      items: [],
      itemsOriginal: [],
      tracker: {},
      types: []
    };
  },
  computed: {
    ...mapState({ navixyUser: (state) => state.navixy.current_user })
  },
  methods: {
    getPaginatedItems,
    formatDate,
    ...mapActions("navixy", ["request"]),
    show(tracker, type) {
      this.activeType = type;
      this.tracker = tracker;
      this.drawer = true;
      this._get_hitory_type();
      this._get_history();
    },
    _get_hitory_type() {
      this.request({
        root: "list",
        panel: false,
        action: "history/type/list"
      }).then((types) => {
        this.types = types;
      });
    },
    _get_history() {
      this.loading = true;
      this.request({
        root: "list",
        panel: false,
        action: "history/tracker/list",
        params: {
          from: this.formatDate(this.dateFilter[0], "YYYY-MM-DD hh:mm:ss"),
          to: this.formatDate(this.dateFilter[1], "YYYY-MM-DD hh:mm:ss"),
          trackers: [this.tracker.id],
          ascending: false
        }
      })
        .then((history) => {
          this.pagination.total = history.length;
          this.itemsOriginal = history;
          this.items = history;
        })
        .finally(() => {
          this.loading = false;
          this.handleCurrentChange(1);
        });
    },
    handleSizeChange(val) {
      this.loading = true;
      this.pagination.pageSize = val;
      const { data } = this.getPaginatedItems(
        this.itemsOriginal,
        this.pagination.currentPage,
        this.pagination.pageSize
      );
      this.loading = false;
      this.items = data;
    },
    handleCurrentChange(val) {
      this.loading = true;
      this.pagination.currentPage = val;
      const { data } = this.getPaginatedItems(
        this.itemsOriginal,
        this.pagination.currentPage,
        this.pagination.pageSize
      );
      this.loading = false;
      this.items = data;
    },
    handleBlurDateFilter() {
      this._get_history();
    },
    getTypeDescription(type) {
      try {
        const tf = this.types.filter((t) => t.type === type);
        return tf[0].description;
      } catch (_) {
        return type;
      }
    }
  }
};
</script>
